import axios from 'axios';

// Detectar URL da API automaticamente
// Em produção (cPanel): usa URL relativa para API local
// Em desenvolvimento: usa REACT_APP_BACKEND_URL
export const getApiBaseUrl = () => {
  // Se está em desenvolvimento com variável de ambiente, usar ela
  if (process.env.REACT_APP_BACKEND_URL && process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Em produção (cPanel), usar URL relativa - API está no mesmo servidor
  // Isso garante que sempre aponta para o servidor onde está instalado
  return window.location.origin;
};

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('doem_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('doem_token');
      localStorage.removeItem('doem_user');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Auth helpers
export const setAuthToken = (token, user) => {
  localStorage.setItem('doem_token', token);
  localStorage.setItem('doem_user', JSON.stringify(user));
};

export const getAuthUser = () => {
  const user = localStorage.getItem('doem_user');
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('doem_token');
};

export const logout = () => {
  localStorage.removeItem('doem_token');
  localStorage.removeItem('doem_user');
};
